import * as React from 'react';
import { useSearchParams } from 'react-router-dom';

export type Vista = 'timeline' | 'feed';

export const VISTAS: Vista[] = ['timeline', 'feed'];
export const CHAVE_VISTA = 'cmp.feed.vista';
/** Quem nunca escolheu cai no Feed (a Timeline é a opção por escolha). */
export const VISTA_PADRAO: Vista = 'feed';

function ehVista(valor: string | null | undefined): valor is Vista {
  return valor === 'timeline' || valor === 'feed';
}

function lerSalva(): Vista | null {
  try {
    const valor = window.localStorage.getItem(CHAVE_VISTA);
    return ehVista(valor) ? valor : null;
  } catch {
    return null; // modo privado / dados bloqueados
  }
}

function salvar(vista: Vista): void {
  try {
    window.localStorage.setItem(CHAVE_VISTA, vista);
  } catch {
    // sem persistência: a escolha vale só nesta sessão da página
  }
}

/**
 * Vista do feed: `?vista=timeline|feed` na URL manda; sem ela vale a última
 * escolha (localStorage); sem nada, o Feed. Escolher grava nos dois.
 */
export function useVista(): [Vista, (vista: Vista) => void] {
  const [params, setParams] = useSearchParams();
  const daUrl = params.get('vista');
  const vista: Vista = ehVista(daUrl) ? daUrl : lerSalva() ?? VISTA_PADRAO;

  const definir = React.useCallback(
    (proxima: Vista) => {
      salvar(proxima);
      setParams(
        (atual) => {
          const novo = new URLSearchParams(atual);
          novo.set('vista', proxima);
          return novo;
        },
        { replace: true },
      );
    },
    [setParams],
  );

  return [vista, definir];
}
